import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from '../app.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NotaFiscalService } from '../services/nota-fiscal/nota-fiscal.service';
import { FaviconService } from '../services/favicon/favicon.service';
import { MatDialog } from '@angular/material/dialog';
import { showError } from 'src/utils/showErrorMessage';
import { handleCNPJCPFFunction } from 'src/utils/handle-cnpj-cpf';

@Component({
  selector: 'spe-demonstrativo',
  templateUrl: './demonstrativo.component.html',
  styleUrls: ['./demonstrativo.component.scss'],
  standalone: false
})
export class DemonstrativoComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  private hashCNPJParceria?: string;
  private idPedido?: string;
  private numeroNotaDeDebito?: string;
  private numeroPrefeitura?: string;
  private numeroRPS?: string;
  private serieNotaDeDebito?: string;
  private serieRPS?: string;

  public pdfUrl!: string;
  public screenWidth!: number;
  public screenHeight!: number;
  public showIframe = false;

  constructor(
    private appComponent: AppComponent,
    private activatedRoute: ActivatedRoute,
    private notaFiscalService: NotaFiscalService,
    private faviconService: FaviconService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.appComponent.hideHeader = true;
    this.getScreenSize();
    this.faviconService.changeFavicon('assets/favicon/64_icon_earth.png');
    this.faviconService.changeTitle('Demonstrativo');
    const queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      //remover o '.pdf' caso venha no ultimo parametro
      let novoParams = { ...params };
      let keyList = Object.keys(params).filter((element) => params[element].includes('.pdf'));
      if (keyList.length > 0) {
        novoParams[keyList[0]] = novoParams[keyList[0]].replace('.pdf', '');
      }

      this.hashCNPJParceria = novoParams.hashCNPJParceria ?? novoParams.CODNDPAR;
      this.idPedido = novoParams.idPedido ?? novoParams.ID_PEDIDO_PED;
      this.numeroNotaDeDebito = novoParams.numeroNotaDeDebito ?? novoParams.NUMNDPAR;
      this.numeroPrefeitura = novoParams.numeroPrefeitura ?? novoParams.NUMPREF;
      this.numeroRPS = novoParams.numeroRPS ?? novoParams.NUMRPS;
      this.serieNotaDeDebito = novoParams.serieNotaDeDebito ?? novoParams.SERNDPAR;
      this.serieRPS = novoParams.serieRPS ?? novoParams.NUMSERIE;

      if (this.hashCNPJParceria) {
        this.hashCNPJParceria = this.getCNPJParceria(this.hashCNPJParceria);
      }

      if (this.serieNotaDeDebito) {
        this.serieNotaDeDebito = this.serieNotaDeDebito.replace(/[\W]/g, '');
      }

      this.notaFiscalService
        .consultarDemonstrativo(
          this.hashCNPJParceria,
          this.idPedido,
          this.numeroNotaDeDebito,
          this.numeroPrefeitura,
          this.numeroRPS,
          this.serieNotaDeDebito,
          this.serieRPS
        )
        .subscribe({
          next: (data) => {
            const url = window.URL.createObjectURL(data);
            this.pdfUrl = url;
            this.showIframe = true;
          },
          error: async (e) => {
            let blob: Blob = e.error;
            let jsonError = JSON.parse(await blob.text());
            showError(this.dialog, jsonError.mensagem);
          }
        });
    });
    this.subscriptions.push(queryParamsSubscription);
  }

  private getCNPJParceria(codndpar: string): string | undefined {
    let retorno: string | undefined = undefined;

    try {
      const [id_parcer_pce, nr_cpf_cnpj, nm_parcer_pce] = atob(codndpar).split('-');
      const { isValid } = handleCNPJCPFFunction(nr_cpf_cnpj);
      if (isValid) {
        retorno = `${nr_cpf_cnpj}${id_parcer_pce}`;
      }
    } catch (error) {
      retorno = undefined;
    }

    return retorno;
  }

  @HostListener('window:resize')
  onResize() {
    this.getScreenSize();
  }

  getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }
}
